import { Modify } from "ol/interaction";
import { Circle, Fill, Stroke, Style } from "ol/style";

export function getModifiedCameraView(layer: any, source: any){
    return new Modify({
        hitDetection: layer,
        source: source,
        style: new Style({
            fill: new Fill({
                color: 'rgb(255,255,255,0.0)',
            }),
            image: new Circle({
                radius: 14,
                stroke: new Stroke({
                    color: 'white', // Измените цвет окружности на белый
                }),
                fill: new Fill({
                    color: 'rgb(255,255,255,0.0)',
                }),
            })
        })
    });
}

export function getModifiedCameraCircle(source: any){
    return new Modify({
        source: source,
        style: new Style({
            fill: new Fill({
                color: 'rgb(255,255,255,0.6)',
            }),
            image: new Circle({
                radius: 14,
                stroke: new Stroke({
                    color: 'rgb(255,255,255,0.6)', // Измените цвет окружности на белый
                }),
                fill: new Fill({
                    color: 'rgb(255,255,255,0.6)',
                }),
            })
        })
    });
}